"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationFieldLogic = void 0;
var duration_fieldtype_1 = require("./duration.fieldtype");
Object.defineProperty(exports, "DurationFieldLogic", { enumerable: true, get: function () { return duration_fieldtype_1.DurationFieldLogic; } });
